import { createAction, props } from '@ngrx/store';
import { SuricataConfiguration } from '../suricata.model';

export const setSuricataConfiguration = createAction(
  '[Suricata] configuration',
  props<{ suricataConfiguration: SuricataConfiguration }>()
);

export const updateSuricataConfiguration = createAction(
  '[Suricata] update',
  props<{ updatedSuricataConfig: SuricataConfiguration }>()
);

export const setIdsDeviceLevelEnabledState = createAction(
  '[Suricata] device level state',
  props<{ updatedIdsState: boolean }>()
);

export const clearSuricataConfiguration = createAction('[Suricata] clear');
